import(/* webpackMode: "eager" */ "/vercel/path0/app/cardapio/layout.tsx");
